import { render } from "./CalcSectionXxl.vue?vue&type=template&id=51d01a5c&scoped=true"
import script from "./CalcSectionXxl.vue?vue&type=script&lang=js"
export * from "./CalcSectionXxl.vue?vue&type=script&lang=js"

import "./CalcSectionXxl.vue?vue&type=style&index=0&id=51d01a5c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51d01a5c"]])

export default __exports__